















































































































































































































































































































































import {
  defineComponent,
  ref,
  computed,
  useRouter,
  useFetch,
} from "@nuxtjs/composition-api";
import { TrackingOrderLists } from "~/modules/customer/composables/useUserOrder/useUserOrder";
import OrderTotals from "~/components/checkingOrder/OrderTotals.vue";
import OrderTracking from "~/components/checkingOrder/OrderTracking.vue";
import { useUserOrder } from "~/modules/customer/composables/useUserOrder";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import { changeImage, formatDateTime, copyCode } from "~/helpers";
import { useUiNotification } from "~/composables";
import { setSizeSwatch } from "~/modules/catalog/category/helpers";
import TrackingInfo from "~/modules/customer/pages/MyAccount/OrderHistory/SingleOrder/TrackingInfo.vue";
import {
  getVariantImage,
  getVariantName,
  getUrlQuery,
  getBgColorValue,
  getColorLabel,
  getSizeLabel,
  getPrice,
} from "~/modules/checkout/helpers";

export default defineComponent({
  name: "OrderDetail",
  components: {
    OrderTotals,
    OrderTracking,
    SkeletonLoader,
    TrackingInfo,
  },
  props: {
    orderDetail: {
      type: [Array, Object],
      required: true,
    },
  },
  setup(props) {
    const { loading, customerTrackingOrder } = useUserOrder();
    const router = useRouter();

    const billingAddress = computed(
      () => props.orderDetail?.[0]?.billing_address
    );

    const address = computed(() => {
      const street = Array.isArray(billingAddress.value?.street)
        ? billingAddress.value.street?.[0]
        : billingAddress.value.street;

      const wardName =
        billingAddress.value?.extension_attributes?.ward_name || "";
      return (
        `${street}, ` +
        `${wardName}, ` +
        `${billingAddress.value?.city}, ` +
        `${billingAddress.value?.region}`
      );
    });

    const payment = computed(() => props?.orderDetail[0]?.payment);
    const orderData = computed(() => props?.orderDetail[0]);
    const items = computed(() => props?.orderDetail[0]?.items);
    const totalItems = computed(() => {
      return items.value?.reduce((total, item) => {
        if (item?.qty_ordered && item?.qty_ordered > 0) {
          return total + item?.qty_ordered;
        }
        return total;
      }, 0);
    });

    const isMore = ref(false);
    const trackingOrderData = ref<TrackingOrderLists[]>(null);
    const classOrderDataDetail = ref("");

    const { send: sendNotification } = useUiNotification();

    useFetch(async () => {
      if (orderData.value) {
        const params = {
          order_code: orderData.value.increment_id,
        };
        const resultTrackingOrder = await customerTrackingOrder(params);
        if (resultTrackingOrder && Array.isArray(resultTrackingOrder.data)) {
          trackingOrderData.value = resultTrackingOrder.data
            .filter((item) => item?.create_date && item.create_date !== "")
            .reverse();
        } else {
          trackingOrderData.value = [];
        }

        classOrderDataDetail.value =
          trackingOrderData.value?.[0]?.order_status ||
          orderData.value?.status ||
          "";
        if (
          classOrderDataDetail.value &&
          classOrderDataDetail.value == "pending"
        ) {
          classOrderDataDetail.value = "Pending";
        }
      }
    });

    const handleCopyCode = (code: string) => {
      copyCode(code);
      let message = `Bạn đã copy mã ${code}`;
      sendNotification({
        id: Symbol("copy_text_success"),
        message: message,
        type: "success",
        icon: "check",
        persist: false,
        title: message,
      });
    };

    const iconPayment = (method) => {
      switch (method) {
        case "cashondelivery":
          return require("@/assets/images/cod.svg");
        case "vnpay":
          return require("@/assets/images/vnpay.svg");
        case "shopee_pay":
          return require("@/assets/images/shopeepay.svg");
        default:
          return "";
      }
    };

    const goToDefault = (path) => {
      let url = `https://canifa.com${path}`;
      window.open(url, "_blank");
    };

    const getOrderInfo = (status: string, payment_method) => {
      switch (status) {
        case "Created":
          return {
            title: "Đang xử lý",
            desStatus: "Đơn hàng đang được tiếp nhận",
            classStatus: "processing",
          };
        case "Validated":
          return {
            title: "Đang xử lý",
            desStatus: "Đơn hàng đang được chuẩn bị",
            classStatus: "processing",
          };
        case "To be Prepared":
          return {
            title: "Đang vận chuyển",
            desStatus: "Đã giao cho đơn vị vận chuyển",
            classStatus: "shipping",
          };
        case "Prepared":
          return {
            title: "Đang vận chuyển",
            desStatus: "Đơn hàng đang trên đường giao",
            classStatus: "shipping",
          };
        case "Package given to carrier":
          return {
            title: "Đã giao",
            desStatus: "Giao hàng thành công",
            classStatus: "delivered",
          };
        case "complete":
          return {
            title: "Đã giao",
            desStatus: "Giao hàng thành công",
            classStatus: "delivered",
          };
        case "Cancel":
          return {
            title: "Đã hủy",
            desStatus: "Đơn hàng của bạn đã được hủy",
            classStatus: "cancel",
          };
        case "Pending":
          if (payment_method !== "cashondelivery") {
            return {
              title: "Chờ thanh toán",
              desStatus: "Đơn hàng đang chờ thanh toán",
              classStatus: "waiting",
            };
          } else {
            return {
              title: "Đang xử lý",
              desStatus: "Đơn hàng đang được tiếp nhận",
              classStatus: "processing",
            };
          }
        default:
          return {
            title: "",
            desStatus: "",
            classStatus: "",
          };
      }
    };

    const getPercent = (originalPrice: number, price: number) => {
      return 100 - Math.round((price / originalPrice) * 100);
    };

    return {
      orderData,
      billingAddress,
      payment,
      items,
      loading,
      trackingOrderData,
      changeImage,
      address,
      formatDateTime,
      handleCopyCode,
      iconPayment,
      goToDefault,
      getOrderInfo,
      classOrderDataDetail,
      totalItems,
      isMore,
      getVariantImage,
      getVariantName,
      getUrlQuery,
      getBgColorValue,
      getColorLabel,
      getSizeLabel,
      getPrice,
      getPercent,
      setSizeSwatch,
    };
  },
});
